import TopNav from '@/components/site/TopNav';
import Hero from '@/components/site/Hero';
import Problem from '@/components/site/Problem';
import Solution from '@/components/site/Solution';
import HowItWorks from '@/components/site/HowItWorks';
import PointOfPurchase from '@/components/site/PointOfPurchase';
import WaitlistForm from '@/components/site/WaitlistForm';
import Footer from '@/components/site/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <TopNav />
      <main className="flex-1">
        <Hero />
        <Problem />
        <Solution />
        <HowItWorks />
        <PointOfPurchase />
        <WaitlistForm />
      </main>
      <Footer />
    </div>
  );
}
